import { Component, inject, TemplateRef } from '@angular/core';
import { MatSortModule, Sort } from '@angular/material/sort';
import { OwnerOverviewComponent } from '../owner-overview/owner-overview.component';
import { BreadcrumbComponent } from '../../../elements/breadcrumb/breadcrumb.component';
import { HttpServiceService } from '../../../services/http-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-tax-info',
  imports: [OwnerOverviewComponent,MatSortModule, BreadcrumbComponent, NgIf, FormsModule, NgFor, DatePipe],
  templateUrl: './tax-info.component.html',
  styleUrl: './tax-info.component.css'
})
export class TaxInfoComponent {
  breadcrumbList : any;
  allData :  any = [
    {
      'document_comment' : 'document_comment',
      'category' : 'category',
      'doc_type' : 'doc_type',
      'property_name' : 'property_name',
      'permission' : 'permission',
      'created' : 'created'
    }
  ];
  page: any = 1;
  totalRows: number = 5;
  totalPage: any = 0;
  private routeSubscription?: Subscription;
  userId: string = '';
  userInvoices : any;
  userProperties : any;
  choosenProperty : string = '';
  private getAllInvoicesSubscription?: Subscription;
  ownerInvoices: any;
  private getBillImagesSubscription?: Subscription;
  private currentLeaseList : any = [];
  private previousLeaseList : any = [];
  currentLease : boolean = true;
  addProperty? : string;

  constructor(private httpService : HttpServiceService, private route: ActivatedRoute, private router: Router){
    this.routeSubscription =  this.route.paramMap.subscribe(params => {
      this.userId = params.get('id') ?? "";
      let userType = params.get('type') ?? "";
      this.breadcrumbList = { 
        breadcrumb_path: userType == "owner" ? "Owners" : "Tenants",
        currentURL: 'Invoices',
        breadcrumb_url : '/admin/'+ (userType == "owner" ? "owners" : "tenants") 
      }
    });
  }

  goBackToList(event : any){    
    this.router.navigate([this.breadcrumbList.breadcrumb_url]);
  }

  getUserDetails(data : any){
    this.userProperties = data["properties"] ?? [];
    let defaultPropertyId = this.userProperties?.length ? this.userProperties[0].uid : "";
    if(defaultPropertyId) {
      this.choosenProperty = defaultPropertyId;
      this.getAllInvoices(defaultPropertyId);
    }
  }

  getPropertyInvoices(){    
    this.getAllInvoices(this.choosenProperty);
  }

  getAllInvoices(propertyId : string){
     this.getAllInvoicesSubscription = this.httpService.getAllLeases(propertyId).subscribe({
      next : (response) => {
        this.currentLeaseList = response.data["active"];
        this.previousLeaseList = response.data["archived"];
        this.ownerInvoices = JSON.parse(JSON.stringify(this.currentLeaseList));
      }
    })
  }

  changeLeases(){
    this.currentLease = !this.currentLease;
    if (this.currentLease) {
      this.ownerInvoices = JSON.parse(JSON.stringify(this.currentLeaseList));
    }
    else {
      this.ownerInvoices = JSON.parse(JSON.stringify(this.previousLeaseList));
    }
  }

  viewImage(imageUrl : string){
    this.getBillImagesSubscription = this.httpService.getBillImages(imageUrl).subscribe({
      next : (response) => {
        window.open(response.data["url"] , "_blank");
      }
    })
  }

  sortData(sort: Sort) {
    const data = this.allData.slice();
    if (!sort.active || sort.direction === '') {
      this.allData = data;
      return;
    }

    this.allData = data.sort((a : any, b : any) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'document_comment': return compare(a.document_comment, b.document_comment, isAsc);
        case 'category': return compare(a.category, b.category, isAsc);
        case 'doc_type': return compare(a.doc_type, b.doc_type, isAsc);
        case 'property_name': return compare(a.property_name, b.property_name, isAsc);
        case 'permission': return compare(a.permission, b.permission, isAsc);       
        case 'created': return compare(a.created, b.created, isAsc);
        default: return 0;
      }
    });
    //this.allData = this.this.allData, this.page, this.totalRows);
  }

  ngOnDestroy(){
    this.routeSubscription?.unsubscribe();
    this.getAllInvoicesSubscription?.unsubscribe();
    this.getBillImagesSubscription?.unsubscribe();
  }
  
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
